module.exports = __webpack_public_path__ + "img/btn_google_signup.a9b4588c.png";